<div class="dashboard-heading">
  <h1>{{ 'ADMIN_PANEL_SERVICES' | translate }}</h1>

  <div>
    <dx-button text="{{ 'SYNC_CATALOG' | translate }}" icon="mdi mdi-sync" class="btn btn-green" (onClick)="this.sync()"></dx-button>
  </div>
</div>

<dx-data-grid
  class="datagrid-admin mb-5"
  [dataSource]="this.services"
  [showBorders]="true"
  [allowColumnResizing]="true"
  [columnMinWidth]="70"
  [columnAutoWidth]="true"
  [masterDetail]="{ enabled: true, template: 'details' }"
  [hoverStateEnabled]="true"
  keyExpr="id"
  stylingMode="outlined"
  rowTemplate="rowTemplate"
  noDataText="{{ 'DATA_NOT_FOUND' | translate }}"
  (onRowClick)="rowClick($event)">
  <!--<dxo-group-panel [visible]="true"></dxo-group-panel>-->
  <!--<dxo-grouping [autoExpandAll]="true"></dxo-grouping>-->

  <dxo-selection mode="single"></dxo-selection>
  <dxo-header-filter [visible]="true" [allowSearch]="true"></dxo-header-filter>

  <dxi-column dataField="code" caption="{{ 'SERVICES_ID' | translate }}" cssClass="border-right"></dxi-column>
  <dxi-column
    [dataField]="this.isLanguageUa ? 'nameUa' : 'nameRu'"
    caption="{{ 'SERVICES_NAME' | translate }}"
    cssClass="border-right"></dxi-column>
  <dxi-column dataField="categoryCode" caption="{{ 'SERVICES_CATEGORIES_ID' | translate }}" cssClass="border-right"></dxi-column>
  <dxi-column dataField="categoryName" caption="{{ 'SERVICES_CATEGORIES_NAME' | translate }}" cssClass="border-right"></dxi-column>
  <dxi-column dataField="categoryNameWeb" caption="{{ 'SERVICES_CATEGORIES_NAME_WEB' | translate }}" cssClass="border-right"></dxi-column>
  <dxi-column
    dataField="masterCategoryCode"
    caption="{{ 'SERVICES_MASTER_CATEGORIES_ID' | translate }}"
    cssClass="border-right"></dxi-column>
  <dxi-column
    dataField="masterCategoryName"
    caption="{{ 'SERVICES_MASTER_CATEGORIES_NAME' | translate }}"
    cssClass="border-right"></dxi-column>
  <dxi-column dataField="isEnabled" caption="{{ 'ACTIVE' | translate }}"></dxi-column>

  <tbody class="dx-row" *dxTemplate="let entity of 'rowTemplate'">
    <tr class="main-row">
      <td>
        @if (entity.isExpanded) {
          <span><i class="mdi mdi-minus mdi-18px"></i></span>
        }
        @if (!entity.isExpanded) {
          <span><i class="mdi mdi-plus mdi-18px"></i></span>
        }
      </td>
      <td class="border-right">
        {{ entity.data.code }}
      </td>
      <td class="border-right">
        {{ this.isLanguageUa ? entity.data.nameUa : entity.data.nameRu }}
      </td>
      <td class="border-right">
        {{ entity.data.categoryCode }}
      </td>
      <td class="border-right">
        {{ entity.data.categoryName }}
      </td>
      <td class="border-right">
        {{ entity.data.categoryNameWeb }}
      </td>
      <td class="border-right">
        {{ entity.data.masterCategoryCode }}
      </td>
      <td class="border-right">
        {{ entity.data.masterCategoryName }}
      </td>
      <td class="text-center">
        <dx-check-box [value]="entity.data.isEnabled" (onValueChanged)="this.clickCheckBox($event, entity)"></dx-check-box>
      </td>
    </tr>
  </tbody>

  <div *dxTemplate="let entity of 'details'">
    <app-service-catalog-details [service]="entity.data" (onSave)="this.onSave($event)"></app-service-catalog-details>
  </div>

  <dxo-paging [pageSize]="15"></dxo-paging>
  <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[15, 50, 100, 1000]"></dxo-pager>
</dx-data-grid>
